import { overlayEventEmitter } from "@made-people/blueprint-overlay";
import { ButtonAsButton } from "@made-people/blueprint-button";
import { useTranslate } from "@made-people/grease-translations";
import { loginDrawerOverlayId, signupDrawerOverlayId } from "../constants";
import { useDrawerNavigation } from "../hooks/use-drawer-navigation";
import { useRegisterForm } from "../hooks/use-register-form";
import { AuthDrawer } from "./AuthDrawer";
import { RegisterForm } from "../forms/RegisterForm";

export const SignupDrawer = () => {
  const translate = useTranslate();
  const { switchToDrawer, resetStateAfterClose } = useDrawerNavigation();

  const form = useRegisterForm({
    onSuccess: () => {
      overlayEventEmitter.emit("close", { overlayId: signupDrawerOverlayId });
      window.location.href = "/comfort-club";
    },
  });

  const switchToLogin = (e: React.MouseEvent) => {
    e.preventDefault();
    resetStateAfterClose(() => {
      form.setFirstName("");
      form.setLastName("");
      form.setEmail("");
      form.setPassword("");
    });
    switchToDrawer(loginDrawerOverlayId);
  };

  return (
    <AuthDrawer
      overlayId={signupDrawerOverlayId}
      heading={translate("Account_Signup_Drawer_Heading")}
    >
      <RegisterForm
        form={form}
        loginAction={
          <ButtonAsButton
            label={translate("Account_Signup_SecondaryAction")}
            onClick={(e) => {
              switchToLogin(e as React.MouseEvent);
            }}
            variants={{ style: "outline", width: "full" }}
          />
        }
      />
    </AuthDrawer>
  );
};
